import {connect} from 'react-redux'
import {toggleBooking} from '../../planner/planner.action'

import {Budget} from './budget.component'

const mapStateToProps = (state) => {
    return {
        legs: state.getIn(['document', 'legs']),
        bookingActive: state.getIn(['uiState', 'bookingActive']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
   		onToggleBooking: () => {
            dispatch(toggleBooking())
        }
    }
}

const BudgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Budget)

export default BudgetContainer
